var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalculatorOn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 21,
    viewBox: "0 0 14 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.16667 0.600098C0.520333 0.600098 0 1.12043 0 1.76676V19.0334C0 19.6798 0.520333 20.2001 1.16667 20.2001H12.8333C13.4797 20.2001 14 19.6798 14 19.0334V1.76676C14 1.12043 13.4797 0.600098 12.8333 0.600098H1.16667ZM2.1 2.7001H11.9V6.2001H2.1V2.7001ZM2.1 8.3001H3.96667V10.1668H2.1V8.3001ZM6.06667 8.3001H7.93333V10.1668H6.06667V8.3001ZM10.0333 8.3001H11.9V10.1668H10.0333V8.3001ZM2.1 12.2668H3.96667V14.1334H2.1V12.2668ZM6.06667 12.2668H7.93333V14.1334H6.06667V12.2668ZM10.0333 12.2668H11.9V18.1001H10.0333V12.2668ZM2.1 16.2334H3.96667V18.1001H2.1V16.2334ZM6.06667 16.2334H7.93333V18.1001H6.06667V16.2334Z",
    fill: "#04B7B1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalculatorOn);
export default __webpack_public_path__ + "static/media/calculatorOn.97ae5a1a5125dd924b5182210b3e31f0.svg";
export { ForwardRef as ReactComponent };